import React, { useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import CommentForm from 'root/src/client/web/form/FormModule/CommentForm'
import TextField from 'root/src/client/web/form/TextFields/MuiStyledTextField'
import { errorColor } from 'root/src/client/web/commonStyles'

const style = {
	root: {
		width: '100%',
	},
	errorText: {
		fontSize: 12,
		color: errorColor,
		fontWeight: 'bold',
	},
}

const AddCommentForm = ({
	classes, creatorData, addComment, isMobileRes, isAuthenticated, addCommentOnSuccess,
}) => {
	const [input, setInput] = useState('')
	const [disabled, setDisabled] = useState(false)
	const [errorText, setErrorText] = useState('')

	return (
		<div className={classes.root}>
			<CommentForm
				creatorData={creatorData}
				isMobileRes={isMobileRes}
				displayForm={isAuthenticated}
				isReply={false}
				submitForm={async () => {
					if (!disabled && input.length) {
						setDisabled(true)
						const { body, error, statusCode } = await addComment({ message: input })
						if (statusCode === 200) {
							if (errorText) setErrorText('')
							addCommentOnSuccess({ body })
						} else if (statusCode === 403) {
							setErrorText(error.message)
						}
						setInput('')
						setDisabled(false)
					}
				}}
			>
				<div className={classes.root}>
					<TextField
						fieldValue={input}
						setInput={setInput}
						autoComplete="off"
						fieldPlaceholder="Add comment..."
					/>
					{errorText && <p className={classes.errorText}>{errorText}</p>}
				</div>
			</CommentForm>
		</div>
	)
}

export default withStyles(style, { name: 'MuiAddCommentForm' })(AddCommentForm)
